import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import MisRutas from "./routes";

 

function App() {
  const getStoredThemeMode = () => {
    const storedTheme = localStorage.getItem("themeMode");
    return storedTheme || "light";
  };
  const [themeMode, setThemeMode] = useState(getStoredThemeMode());

  const toggleTheme = () => {
    const newThemeMode = themeMode === "light" ? "dark" : "light";
    setThemeMode(newThemeMode);
    localStorage.setItem("themeMode", newThemeMode);
  };

  return (
    <Router>
      <React.StrictMode>
            <MisRutas toggleTheme={toggleTheme} themeMode={themeMode} />
      </React.StrictMode>
    </Router>
  );
}

export default App;
